import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {IpDirecctionContext} from '../../contexts/IpDirecctionContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import axios from 'axios';
import logo from '../../assets/logoCuidatia5.png';
import {LoginExterno} from '../../components/login/LoginExterno';
import {useParams} from 'react-router-dom';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
/**
 * A function that is used to log in to the application
 * @returns A form that allows the user to log in to the application.
 */
export const FormularioLoginStandar = (props) => {
	const {goTo} = useParams();

	const {type} = props;

	/* A hook that allows you to navigate between routes. */
	const navigate = useNavigate();

	/* Setting the state of the form. */
	const [FormState, setFormtState] = useState({
		email: '',
		password: '',
	});

	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [IpDirection, setIpDirection] = useSessionStore(UsuarioContext);
	const [ModalNoLogin, setModalNoLogin] = useState(false);

	const is_admin = (rsp) => {
		axios({
			method: 'get',
			url: window.ipdirection + '/prestadorServiciosAdmin/?page=1&type=pendiente',
			headers: {
				Authorization: 'Bearer ' + rsp.data.access,
			},
		})
			.then((response) => {
				setUsuario({
					...Usuario,
					access: rsp.data.access,
					refresh: rsp.data.refresh,
					tipo: 'usuarioAdmin',
				});
				navigate('/empresas');
			})
			.catch((error) => {
				console.log(error);
				setFormtState({
					email: '',
					password: '',
				});
				setModalNoLogin(true);
			});
	};
	/**
	 * It sends a POST request to the server, and then sets the state of the componen with the
	 * response data.
	 */
	const getTokensAdmin = () => {
		axios({
			method: 'post',
			url: window.ipdirection + 'auth/login/',
			data: {
				email: FormState.email,
				password: FormState.password,
			},
		})
			.then((response) => {
				is_admin(response);
			})
			.catch((error) => {
				setFormtState({
					email: '',
					password: '',
				});
				setModalNoLogin(true);
			});
	};
	const getTokensEmpresa = () => {
		axios({
			method: 'post',
			url: window.ipdirection + 'auth/login/',
			data: {
				email: FormState.email,
				password: FormState.password,
			},
		})
			.then((response) => {
				let usuario = {
					access: response.data.access,
					refresh: response.data.refresh,
					tipo: 'usuarioEmpresa',
				};
				getDatosEmpresa(usuario);
			})
			.catch((error) => {
				setFormtState({
					email: '',
					password: '',
				});
				setModalNoLogin(true);
			});
	};

	const getDataCliente = (access, refresh) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'clienteByCliente/',
			headers: {
				Authorization: 'Bearer ' + access,
			},
		})
			.then((response) => {
				let usuario = {
					access: access,
					refresh: refresh,
					tipo: 'usuarioNormal',
					cliente: response.data[0],
				};
				recomendacionesCliente(usuario);
				setUsuario({...usuario});

				navigate('/miPerfil');
			})
			.catch((error) => {
				console.log(error);
				setFormtState({
					email: '',
					password: '',
				});
				setModalNoLogin(true);
			});
	};

	const getUserData = async (access, refresh) => {
		try {
			// Intentamos como cliente
			const clienteResponse = await axios({
				method: 'get',
				url: window.ipdirection + 'clienteByCliente/',
				headers: { Authorization: 'Bearer ' + access },
			});

			let usuario = {
				access,
				refresh,
				tipo: 'usuarioNormal',
				cliente: clienteResponse.data[0],
			};

			recomendacionesCliente(usuario);
			setUsuario(usuario);
			navigate('/');
			return;

		} catch (errorCliente) {
			// Si no fue cliente, intentamos como empresa
			try {
				axios({
					method: 'get',
					url: window.ipdirection + 'prestadorServicios/',
					headers: {
						Authorization: 'Bearer ' + access,
					},
				})
					.then((response) => {
						// Introduciomos los datos del presatador de servicios al usuario
						let usuarioAux = {
							access,
							refresh,
							tipo: 'usuarioEmpresa',
							prestadorServicios: response.data[0]
						};
						setUsuario({...usuarioAux});
						navigate('/miEmpresa');
					})
					.catch((error) => {
						console.log(error);
						setFormtState({
							email: '',
							password: '',
						});
						setModalNoLogin(true);
					});

				return;

			} catch (errorEmpresa) {
				// Si falla todo, mostramos error
				console.log('No es cliente ni empresa');
				setFormtState({
					email: '',
					password: '',
				});
				setModalNoLogin(true);
			}
		}
	};


	const recomendacionesCliente = (usuario) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'recomendaciones?user=' + usuario.cliente.usuario.id,
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		})
			.then((response) => {
				setUsuario({...usuario, recomendaciones: response.data});
			})
			.catch((error) => {});
	};

	const getImagenPerfil = (usuario) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilCliente/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
			//rob.ertor.hr96@gmail.com
		})
			.then((response) => {
				if (response.data.length > 0) {
					axios({
						method: 'get',
						url:
							window.ipdirection +
							'imagenPerfilCliente/' +
							response.data[0].id.toString() +
							'/',
						headers: {
							Authorization: 'Bearer ' + usuario.access,
						},
						responseType: 'blob',
					})
						.then((response2) => {
							let foto = URL.createObjectURL(response2.data);
							setUsuario({...usuario, fotoPerfil: foto});
							if (goTo !== null) {
								if (goTo !== undefined) {
									const parts = goTo.split('-');
									let part1 = '/' + parts[0];
									if (parts.length > 1) {
										part1 = part1 + '/' + parts[1];
									}
									navigate(part1);
								} else {
									navigate('/');
								}
							} else {
								navigate('/');
							}
						})
						.catch((error) => {
							console.log(error);
							setUsuario({...usuario});
							if (goTo !== null) {
								if (goTo !== undefined) {
									const parts = goTo.split('-');
									let part1 = '/' + parts[0];
									if (parts.length > 1) {
										part1 = part1 + '/' + parts[1];
									}
									navigate(part1);
								} else {
									navigate('/');
								}
							} else {
								navigate('/');
							}
						});
				}
			})
			.catch((error) => {
				console.log(error);
				setUsuario({...usuario});
				if (goTo !== null) {
					if (goTo !== undefined) {
						const parts = goTo.split('-');
						let part1 = '/' + parts[0];
						if (parts.length > 1) {
							part1 = part1 + '/' + parts[1];
						}
						navigate(part1);
					} else {
						navigate('/');
					}
				} else {
					navigate('/');
				}
			});
	};

	const getTokenCliente = () => {
		axios({
			method: 'post',
			url: window.ipdirection + 'auth/login/',
			data: {
				email: FormState.email,
				password: FormState.password,
			},
		})
			.then((response) => {
				getDataCliente(response.data.access, response.data.refresh);
			})
			.catch((error) => {
				setFormtState({
					email: '',
					password: '',
				});
				setModalNoLogin(true);
			});
	};
	/**
	 * It makes a GET request to the URL http://localhost:8000/prestadorServicios/ and then sets the
	 * state of the listaCategorias variable to the response.data.
	 */
	const getDatosEmpresa = (usuario) => {
		/* Making a request to the server to get the data. */
		axios({
			method: 'get',
			url: window.ipdirection + 'prestadorServicios/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		})
			.then((response) => {
				// Introduciomos los datos del presatador de servicios al usuario
				let usuarioAux = {...usuario, prestadorServicios: response.data[0]};
				console.log('usuarioAux', usuarioAux)
				setUsuario({...usuarioAux});
				navigate('/miEmpresa');
				//selectFotoPerfil(usuarioAux);
			})
			.catch((error) => {
				console.log(error);
				setFormtState({
					email: '',
					password: '',
				});
				setModalNoLogin(true);
			});
	};

	const colocarFoto = (usuario, foto) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilEmpresa/' + foto.id.toString() + '/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
			responseType: 'blob',
		})
			.then((response) => {
				console.log('Entra')
				setUsuario({...usuario, fotoPerfil: URL.createObjectURL(response.data)});
				navigate('/miEmpresa');
			})
			.catch((error) => {
				setUsuario({
					...usuario,
					fotoPerfil:
						window.ipdirection +
						'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
				});
				navigate('/miEmpresa');
				//setErroresFormulario(["Error al cargar la foto de perfil"])
				//setModalErrores(true)
			});
	};
	const selectFotoPerfil = (usuario) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilEmpresa/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		})
			.then((response) => {
				console.log(response.data);
				colocarFoto(usuario, response.data[0]);
			})
			.catch((error) => {
				console.log('Error Al cargar la foto de perfil')
				setUsuario({...usuario});
				navigate('/miEmpresa');
				//setErroresFormulario(["Error al cargar la foto de perfil"])
				//setModalErrores(true)
			});
	};

	/**
	 * If the user is an admin, get the tokens and navigate to the admin page.
	 *
	 * If the user is an employee, get the tokens and navigate to the employee page.
	 *
	 * If the user is neither, do nothing.
	 */
	const login = () => {
		// if (type === 'admin') {
		// 	getTokensAdmin();
		// } else if (type === 'empresa') {
		// 	getTokensEmpresa();
		// } else {
		// 	getTokenCliente();
		// }

		axios({
			method: 'post',
			url: window.ipdirection + 'auth/login/',
			data: {
				email: FormState.email,
				password: FormState.password,
			},
		})
		.then((response) => {
			getUserData(response.data.access, response.data.refresh);
		})
		.catch((error) => {
			setFormtState({
				email: '',
				password: '',
			});
			setModalNoLogin(true);
		});
	};

	/**
	 * OnHandleChange is a function that takes an event as an argument and sets the state of
	 * UsuarioCliente to the value of the event target's name property.
	 */
	const onHandleChange = (event) => {
		setFormtState({
			...FormState,
			[event.target.name]: event.target.value,
		});
	};

	const [NumInput, setNumInput] = useState(0);

	const inpust = ['email', 'password'];
	useEffect(() => {
		if (NumInput === 2) {
			login();
		}
	}, [NumInput]);

	const changeFocus = (event) => {
		if (event.key === 'Enter' || event.key === 'ArrowDown') {
			setNumInput(NumInput + 1);
			let nextInputName = inpust[NumInput + 1];
			document.getElementById(nextInputName).focus();
		} else if (event.key === 'ArrowUp') {
			setNumInput(NumInput - 1);
			let nextInputName = inpust[NumInput - 1];
			document.getElementById(nextInputName).focus();
		}
	};
	const changeFocusClick = (event) => {
		let contador = 0;
		inpust.map((input) => {
			if (input === event.target.name) {
				document.getElementById(input).focus();
				setNumInput(contador);
			}
			contador++;
		});
	};
	/* Returning a form that allows the user to log in to the application. */
	return (
		<>
			<Modal
				centered={true}
				isOpen={ModalNoLogin}
			>
				<ModalHeader>
					<div className='titulo-modal'>Oops, algo salió mal</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Ups, tus credenciales no son correctas. Revisa tu correo electrónico y
						contraseña e inténtalo de nuevo. Si aún no puedes acceder, no te preocupes,
						nuestro equipo de soporte está listo para ayudarte. ¡Contáctanos!
					</div>
				</ModalBody>
				<ModalFooter>
					<div
						className='button'
						onClick={() => setModalNoLogin(false)}
					>
						<b>Aceptar</b>
					</div>
				</ModalFooter>
			</Modal>
			{/* <div className='formUsuReg'>
				<div className='contentFormularioUsuarioPacientes'>
					<div className='logoLateral'>
						<div className='centrador'>
							<img src={logo} />
						</div>
					</div>
					<div className='formRegistroDatos'>
						<div className='centradorLeft'>
							{type === 'cliente' ? (
								<h2>
									<b>Accede a Cuidatia</b>
								</h2>
							) : type === 'empresa' ? (
								<h2>
									<b>Accede a Cuidatia</b>
								</h2>
							) : (
								type === 'admin' && (
									<h2>
										<b>Inicio de sesión como administrador</b>
									</h2>
								)
							)}
						</div>
						<div className='separador' />

						<div className='datoFormularioUsuarioRegistro'>
							<div className='labelDatoFormUsu'>Email</div>
							<div className='inputRegistro'>
								<input
									type='email'
									Id='email'
									className='inputTextUsuario'
									placeholder='email@ejemplo.com'
									name='email'
									value={FormState.email}
									onChange={(event) => onHandleChange(event)}
									onClick={(event) => changeFocusClick(event)}
									onKeyDown={(event) => changeFocus(event)}
								/>
							</div>
						</div>
						<div className='datoFormularioUsuarioRegistro'>
							<div className='labelDatoFormUsu'>Contraseña</div>
							<div className='inputRegistro'>
								<input
									type='password'
									Id='password'
									className='inputTextUsuario'
									placeholder='***********'
									name='password'
									value={FormState.password}
									onChange={(event) => onHandleChange(event)}
									onClick={(event) => changeFocusClick(event)}
									onKeyDown={(event) => changeFocus(event)}
								/>
							</div>
						</div>

						<div className='extraLogin'>
							<div className='link1'>
								<div className='linkFormLogin '>
									<div onClick={() => navigate('/olvidarContrasena')}>
										<b>¿Has olvidado la contraseña?</b>
									</div>
								</div>
							</div>
							<div className='buttonLogin'>
								<div
									className='button'
									onClick={login}
								>
									<b>Iniciar sesión</b>
								</div>
							</div>
							{type === 'cliente' ? (
								<>
									<div className='separador sep2' />
									<div className='link2'>
										<div>
											¿Todavía no te has unido a Cuidatia?{' '}
											<b onClick={() => navigate('/registro')}>
												regístrese aquí.
											</b>
										</div>
										<div>
											¿Representas a una empresa?{' '}
											<b onClick={() => navigate('/loginEmpresa')}>
												haga click aquí.
											</b>
										</div>
									</div>
								</>
							) : type === 'empresa' ? (
								<>
									<div className='separador ' />
									<div className='linkFormLogin '>
										<div>
											Registre su empresa{' '}
											<b onClick={() => navigate('/registroEmpresa')}>aquí</b>
										</div>
									</div>
								</>
							) : (
								type === 'admin' && (
									<>
										<div className='separador' />
										<div className='linkFormLogin '>
											<div>
												<b>
													Esta pagina no debe ser visitada por gente
													externa a Adiper{' '}
												</b>
											</div>
										</div>
									</>
								)
							)}
						</div>
					</div>
				</div>
			</div>
		{
			type === 'empresa' ?
			<div className='anuClubCuidatia'>
				<div className='cbIzquierda'>
					<h2>¿Ya conoces Club Cuidatia?</h2>
					<p>Quieres saber los beneficios de Club Cuidatia</p>
				</div>
				<div className='cbDerecha'>
					<div className='buttonLogin'>
						<div
							className='button'
						>
							<b onClick={() => navigate('/club-cuidatia')}>Saber más</b>
						</div>
					</div>
				</div>
			</div> */}
			<div className="">
				<div className="row min-vh-80">
					<div className="col-lg-4 d-none d-lg-block logoLateral">
					<div className="centrador text-center">
						<img src={logo} alt="Logo" className="img-fluid w-50" />
					</div>
					</div>
	
					<div className="col-lg-8 col-md-12 d-flex align-items-center justify-content-center">
					<div className="w-100" style={{ maxWidth: '530px', backgroundColor: '#fff', padding: '2rem', borderRadius: '12px', boxShadow: '0 0 15px rgba(0,0,0,0.05)'  }}>
						<h2 className="mb-4 ">
							<strong>Accede a Cuidatia</strong>
						</h2>

						<div className="mb-3">
						<label htmlFor="email" className="form-label">
							Email
						</label>
						<input
							type="email"
							id="email"
							className="form-control text-dark"
							placeholder="email@ejemplo.com"
							name="email"
							value={FormState.email}
							onChange={(event) => onHandleChange(event)}
							onClick={(event) => changeFocusClick(event)}
							onKeyDown={(event) => changeFocus(event)}
						/>
						</div>

						<div className="mb-3">
						<label htmlFor="password" className="form-label">
							Contraseña
						</label>
						<input
							type="password"
							id="password"
							className="form-control text-dark"
							placeholder="***********"
							name="password"
							value={FormState.password}
							onChange={(event) => onHandleChange(event)}
							onClick={(event) => changeFocusClick(event)}
							onKeyDown={(event) => changeFocus(event)}
						/>
						</div>

						<div className="d-flex justify-content-between align-items-center mb-3">
						<div
							className="link-politica-privacidad-empresas fw-bold"
							role="button"
							onClick={() => navigate('/olvidarContrasena')}
						>
							¿Has olvidado la contraseña?
						</div>
						</div>

						<div className="d-grid mb-4">
						<button className="btn btn-primary fw-bold" onClick={login}>
							Iniciar sesión
						</button>
						</div>

						<div className="text-center text-muted small">
						¿Todavía no te has unido a Cuidatia?{' '}
						<span
							className="link-politica-privacidad-empresas fw-bold"
							role="button"
							onClick={() => navigate('/registro')}
						>
							Regístrate aquí.
						</span>
						</div>
					</div>
					</div>
				</div>
			</div>
		</>
	);
};
